<template>
  <div class="seomain">
    <st-header
      title="我的客户"
      :back-able="true"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
      </template>
    </st-header>

    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <van-search
        v-model="clienter_name"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入客户搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="type == 0" class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
				    <div class="st-list-top st-list-top-with-status">
							<div class="t-tit">{{ v.name }}</div>
              <div class="t-status">{{ statusLabel(v) }}</div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
              <div class="st-field"><span class="st-field-label">国家</span><span class="st-field-value">{{ v.country_id || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户简称</span><span class="st-field-value">{{ v.abbreviation || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">账期</span><span class="st-field-value">{{ v.before_payment || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">联系人</span><span class="st-field-value">{{ v.contactone || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">联系电话</span><span class="st-field-value">{{ v.contactonenumber || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">备注</span><span class="st-field-value">{{ v.remark || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">创建时间</span><span class="st-field-value">{{ v.createtime_text || '--' }}</span></div>
				    </div>
						<div class="st-list-bottom-2">
							<div class="st-action-wrap">
								<div class="st-list-bottom-xs st-action-edit">
									<router-link :to="'/customer/save?id=' + v.id" class="st-opt-btn">编辑</router-link>
								</div>
							</div>
							<van-button v-if="v.status == 0" @click="approval(v.id)" type="info" class="st-opt-btn st-action-btn">提交申请</van-button>
						</div>
				   
				  </div>
				</van-list>
			</div>
			<div v-show="type == '1'" class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top st-list-top-with-status">
              <div class="t-tit">{{ v.name }}</div>
              <div class="t-status">{{ statusLabel(v) }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
             <div class="st-field"><span class="st-field-label">国家</span><span class="st-field-value">{{ v.country_id || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">客户简称</span><span class="st-field-value">{{ v.abbreviation || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">账期</span><span class="st-field-value">{{ v.before_payment || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">联系人</span><span class="st-field-value">{{ v.contactone || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">联系电话</span><span class="st-field-value">{{ v.contactonenumber || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">备注</span><span class="st-field-value">{{ v.remark || '--' }}</span></div>
             <div class="st-field"><span class="st-field-label">创建时间</span><span class="st-field-value">{{ v.createtime_text || '--' }}</span></div>
            </div>
           <div class="st-list-bottom-2">
           	<div class="st-action-wrap">
           		<div class="st-list-bottom-xs st-action-edit">
           			<router-link :to="'/customer/save/' + v.id" class="st-opt-btn">编辑</router-link>
           		</div>
           	</div>
           	<van-button v-if="v.status == 0" @click="approval(v.id)" type="info" class="st-opt-btn st-action-btn">提交申请</van-button>
           </div>
          </div>
        </van-list>
      </div>
      <div v-show="type == '2'" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top st-list-top-with-status">
              <div class="t-tit">{{ v.name }}</div>
              <div class="t-status">{{ statusLabel(v) }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
              <div class="st-field"><span class="st-field-label">国家</span><span class="st-field-value">{{ v.country_id || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户简称</span><span class="st-field-value">{{ v.abbreviation || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">账期</span><span class="st-field-value">{{ v.before_payment || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">联系人</span><span class="st-field-value">{{ v.contactone || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">联系电话</span><span class="st-field-value">{{ v.contactonenumber || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">备注</span><span class="st-field-value">{{ v.remark || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">创建时间</span><span class="st-field-value">{{ v.createtime_text || '--' }}</span></div>
            </div>
            <div class="st-list-bottom-2">
            	<div class="st-action-wrap">
            		<div class="st-list-bottom-xs st-action-edit">
            			<router-link :to="'/customer/save?id=' + v.id" class="st-opt-btn">编辑</router-link>
            		</div>
            	</div>
            	<van-button v-if="v.status == 0" @click="approval(v.id)" type="info" class="st-opt-btn st-action-btn">提交申请</van-button>
							<van-button v-if="v.status == 1" @click="openApproveDetail(v.id)" type="primary" class="st-opt-btn st-action-btn">审批详情</van-button>
            </div>
          </div>
        </van-list>
      </div>
      
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>
    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
      <div class="mix-detail-box">
        <h2>确认收款</h2>
        <p>订单号：{{ oneinfo.ordercode }}</p>
      </div>
    </van-dialog>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
			tabs: [
				{ title: '全部', type: '0' },
				{ title: '待审批', type: '1' },
				{ title: '审批中', type: '2' },
			],
      cur: 0,
			type: 0,
      show: !1,
			
			mode: this.$route.params.mode,
      oneinfo: {},
      stlist0: [],
      stlist1: [],
      stlist2: [],
      exShow: false,
      exDataList: [], // 物流信息
      exDialogTitle: "",
      clienter_name: "", // 关键字搜索
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
			
    };
  },
  watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
  methods: {
    statusLabel(row) {
      if (row && row.status_text) return row.status_text;
      const statusMap = {
        0: "待审批",
        1: "审批中",
        2: "审批通过",
      };
      return statusMap[Number((row && row.status) || 0)] || this.tabs[this.cur].title || "";
    },
    // 添加客户
    addOrder() {
      this.$router.push(`/customer/save`);
    },
		
		// 提交申请
		approval(id) {
			this.$post(this.$api.stCustomerApproval, {'ids': id}).then((res) => {
				if (res.code == 1) {
					this.$toast.success('提交成功');
				} else {
					this.$toast.fail((res.msg ? res.msg : '提交异常，请稍后重试'));
				}
			});
		},
		// 查看审批详情
		openApproveDetail(id) {
			this.$router.push(`/common/approveDetail/4?id=${id}`);
		},
   
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("sale_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("sale_activeIndex", value);
    },
    // 分页
    async onLoad() {
			let typeMap = {'0': 'all', '1': 'unsubmit', '2': 'approving' };
			let type = this.tabs[this.cur]['type'];
      let result = await this.$post(this.$api.stCustomerList, {
        name: this.clienter_name,
        tag: typeMap[type],
        page: this.page,
      });
      if (result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.type].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let { logisticser, courier } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = logisticser + ": " + courier;
      let result = await this.$post(this.$api.stGetXiaoshouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    onSearch(val) {
			this.touchLong = false;
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {
				"del": { text: '删除', value: 'del' },
				"delUnsubmit": { text: '删除', value: 'delUnsubmit' },
			};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					children = ['del'];
				}  else if (v.type == 1) {
					children = ['delUnsubmit'];
				} else if (v.type == 2) {
					children = [];
				}
				if (children.length > 0)  options[v.type] = JSON.parse(JSON.stringify(option));
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand(sign, params) {
			console.log(sign);
			if (sign == 'cancel') {
				this.touchLong = false;
				return;
			}
			
			let checkedIds = this.getCheckIds();
			if (!checkedIds || Object.keys(checkedIds).length <= 0) {
				this.$toast.fail('请选择客户');
				return;
			}
		
			// 删除
			if (sign == 'del') {
				this.del(checkedIds, this.$api.stCustomerDel);
			} else if (sign == 'delUnsubmit') {
				this.del(checkedIds, this.$api.stCustomerDelUnsubmit);
			}
		},
		
		// 删除订单
		del(id, api) {
			this.$confirm('您正在进行客户删除操作，是否继续进行？').then((data) => {
				this.$post(api, {ids: id}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了删除操作');
			});
		},
		// #region-edn 批量操作相关方法
		
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.st-list-box{
	margin: 0px 24px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.keyword {
  position: fixed;
  margin-bottom: 16px;
  width: 100%;
  top: 98px;
	.van-search {
		padding-left: 28px;
		padding-right: 28px;
	}
	
}
.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
  gap: 8px;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: 100%;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  .st-field {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px dashed #f1f3f7;
  }
  .st-field:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .st-field-label {
    flex: 0 0 90px;
    color: #7d8697;
  }
  .st-field-label::after {
    content: "：";
  }
  .st-field-value {
    flex: 1;
    min-width: 0;
    color: #394150;
    word-break: break-all;
  }
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
  overflow-x: hidden;
  height: 62px;
  min-height: 62px;
  align-items: center;
  padding: 2px 0 4px;
  box-sizing: border-box;
}
.tab-tilte.four .text-center {
  flex: 1;
  min-width: 0;
  height: 100%;
}
.tab-tilte.four .text-center span {
  font-size: 14px;
  line-height: 1;
}
.tab-tilte.four .active span {
  display: block;
  margin: 0 4px;
  padding: 10px 10px;
  border-radius: 999px;
}
.st-list-top-with-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.st-list-top-with-status .t-tit {
  flex: 1;
  min-width: 0;
}
.st-list-top-with-status .t-status {
  flex: 0 0 auto;
  color: #2a82e4;
  font-weight: 600;
}
.st-action-wrap {
  flex: 1;
  padding: 0 8px;
  height: 44px;
  min-width: 0;
}
.st-action-btn,
.st-action-wrap .st-list-bottom-xs {
  margin-top: 0;
  height: 42px;
  line-height: 42px;
  border-radius: 5px;
}
.st-action-btn {
  flex: 1;
}
.st-action-wrap .st-list-bottom-xs {
  padding: 0;
}
.st-action-wrap .st-opt-btn {
  display: block;
  margin-top: 8px;
  padding-top: 14px;
}
.st-action-edit {
  background-color: orange;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
